<template lang="pug">
    article#depoimentos
        section#listaDepoimentos
            h2 Depoimentos
            .visualizador
                .video(v-if="depoimentoAtivo.video")
                    video(:src="depoimentoAtivo.video", ref="video")
                    div.controls(@click.prevent="playPauseVideo()")
                        button.play(v-if="paused")
                            include ../../assets/svgs/icones/icone_play.svg
                        button.pause(v-else)
                            include ../../assets/svgs/icones/icone_pause.svg
                .texto(v-else)
                    vuescroll(:ops="opcoes")
                        .content(v-html="depoimentoAtivo.texto")
                img.celular(src="@images/depoimentos/mao-depoimentos.png")
            .depoimentos
                vuescroll(:ops="opcoes")
                    .depoimento(v-for="depoimento, index in depoimentos", :class="{ ativo: ativo == index }", @click="toggleVideo(index)")
                        picture
                            img(:src="depoimento.thumb_autor_link", :alt="depoimento.nome", v-if="depoimento.thumb_autor_link")
                            img(src="@images/depoimentos/thumb-pessoa.png", :alt="depoimento.nome", v-else)
                        .identificacao
                            p.nome {{ depoimento.nome }}
                            p.profissao {{ depoimento.descricao }}
</template>

<script>
import vuescroll from 'vuescroll'
import pagina from '@/mixins/pagina'

export default {
    name: "view-depoimentos",
    components: {
        vuescroll
    },
    mixins: [
        pagina
    ],
    data() {
        return {
            depoimentos: [],
            ativo: 0,
            paused: true,
            opcoes: {
                bar: {
					background: '#121212',
					keepShow: true,
					size: "4px"
				},
				rail: {
					background: "false",
					size: "4px",
					keepShow: false,
					opacity: 1,
				}
            }
        }
    },
    created() {
        this.loadDepoimentos()
    },
    computed: {
        depoimentoAtivo() {
            if (!this.depoimentos[this.ativo])
                return {}
            if (this.depoimentos[this.ativo].media_link)
                return {
                    video: this.depoimentos[this.ativo].media_link
                }
            return {
                texto: this.depoimentos[this.ativo].conteudo
            }
        }
    },
    methods: {
        loadDepoimentos() {
            this.$axios
                .get(`depoimentos`)
                .then(response => this.depoimentos = response.data.registros)
        },
        playPauseVideo(keepPaused = false) {
            if (keepPaused) {
                this.paused = true
                this.$refs.video.pause()
            } else {
                this.paused = !this.paused
                if (this.$refs.video.paused || this.$refs.video.ended)
                    this.$refs.video.play()
                else
                    this.$refs.video.pause()
            }
        },
        toggleVideo(index) {
            this.ativo = index
            this.playPauseVideo(true)
        }
    },
}
</script>

<style lang="stylus" scoped src="./Depoimentos.styl"></style>